<template>
<svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M11.2502 24.9001L19.4002 16.7501C20.3627 15.7876 20.3627 14.2126 19.4002 13.2501L11.2502 5.1001" stroke="white" stroke-width="2.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
</svg>

</template>
